import { render, staticRenderFns } from "./Inquiry.vue?vue&type=template&id=f0ec8e2a&"
import script from "./Inquiry.vue?vue&type=script&lang=ts&"
export * from "./Inquiry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports